"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var React = _interopRequireWildcard(require("react"));
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _instants = require("web/shared/jobs/instants.js");
var _logBlockStyles = require("web/shared/jobs/logBlock.styles.js");
var _jobsViewsStyles = require("web/shared/jobs/jobsViews.styles.js");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* A recorded log, rendered as a scrolling block of lines.
*
* Lines keep their emitted order (oldest first) so the block reads the way
* the process actually ran, and the block scrolls inside itself so a long log
* never pushes the rest of the page away.
*/
function JobLogView(_ref) {
  let logs = _ref.logs,
    emptyMessage = _ref.emptyMessage;
  if (logs.length === 0) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_jobsViewsStyles.styles.statusNeutral)), {}, {
      children: emptyMessage
    }));
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_logBlockStyles.styles.logBlock)), {}, {
    children: logs.map((line, index) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_logBlockStyles.styles.logLine)), {}, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_logBlockStyles.styles.logTime)), {}, {
        children: (0, _instants.formatTime)(line.at)
      })), "  ", /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_logBlockStyles.styles.logLevel)), {}, {
        children: line.level.toLowerCase()
      })), "  ", line.message]
    }), "".concat(line.at, "-").concat(String(index))))
  }));
}
var _default = exports.default = JobLogView;